/// <amd-module name="VSS/Diagnostics/UI/Components/FaultInjection/FaultInjection" />
import * as React from "react";

import { Components, WrappedComponent } from "VSS/Platform/Layout";

import { Section } from "VSS/Diagnostics/UI/Section";

import { getCookie } from "VSS/Platform/Util/Cookie";

interface FaultInjectionState {
    showFaultInjectionDialog: boolean;
    isFaultInjected: boolean;
}

class FaultInjection extends React.Component<{}, FaultInjectionState> {
    public state = { showFaultInjectionDialog: false, isFaultInjected: getCookie("AzDevRequestFaults") ? true : false };

    public render(): JSX.Element {
        return (
            <React.Fragment>
                <span
                    className="perf-section actionable"
                    onClick={this.showFaultInjectionDialog}
                    style={{ backgroundColor: this.state.isFaultInjected ? "Red" : "" }}
                >
                    <span className="perf-section-label">{"Fault Injection " + (this.state.isFaultInjected ? "On" : "Off")}</span>
                </span>

                {this.state.showFaultInjectionDialog ? (
                    <WrappedComponent
                        dependencies={["ms.vss-features.diag-dialog-content"]}
                        wrappedType="vss.perf-fault-dialog"
                        onDismiss={this.hideFaultInjectionDialog}
                        onFaultChanged={this.onFaultChanged}
                    />
                ) : null}
            </React.Fragment>
        );
    }

    private hideFaultInjectionDialog = () => {
        this.setState({ showFaultInjectionDialog: false });
    };

    private showFaultInjectionDialog = () => {
        this.setState({ showFaultInjectionDialog: true });
    };

    private onFaultChanged = (on: boolean) => {
        this.setState({ isFaultInjected: on });
    };
}

Components.add("perfbar.faultInjection", FaultInjection);
